// extracted by mini-css-extract-plugin
module.exports = {"contacts-title":"contacts-title__2DDp6","contactsTitle":"contacts-title__2DDp6","footer-item":"footer-item__2kWrm","footerItem":"footer-item__2kWrm","item":"item__2dHb7"};